/**
 * The pick · test · read · update · decay rail of one cycle
 * (spec #43 §3's `CycleStep[]`, rendered inline per #44 §1.3).
 *
 * Steps are shown in the order the server recorded them and NONE is
 * dropped: a refused step inside an otherwise-successful cycle is the most
 * informative row on the screen — it is where a gate stopped the run — so
 * it keeps its reason and is drawn as the gate it is.
 */

import type { CycleStep } from '../../types/timeline';
import styles from './workspace.module.css';

function stepClass(status: string): string {
  if (status === 'failed') return styles.stepFailed;
  if (status === 'refused' || status === 'skipped') return styles.stepRefused;
  return '';
}

export function CycleStepsRail({
  entryId,
  steps,
}: {
  entryId: string;
  steps: CycleStep[];
}) {
  return (
    <div className={styles.steps} data-testid={`cycle-steps-${entryId}`}>
      {steps.map((step) => (
        <div
          key={`${step.seq}-${step.step}`}
          className={`${styles.step} ${stepClass(step.status)}`}
        >
          <span className={styles.stepName}>{step.step}</span>
          <span>{step.status}</span>
          {step.reason ? <span>{step.reason}</span> : null}
          {step.duration_ms !== null ? (
            <span className={styles.mono}>{step.duration_ms}ms</span>
          ) : null}
        </div>
      ))}
    </div>
  );
}
